module.exports = __webpack_public_path__ + "static/media/message-empty.92e7ea57.svg";